import React, { useEffect, useState } from 'react';
import RateService from '../services/RateService.js';
import { Link } from 'react-router-dom';
import ReactQuill from 'react-quill';
import NewsService from '../services/NewsService';
import { useSelector } from 'react-redux';
import AuthenticatedComponent from './AuthenticatedComponent';

function Home() {
  const { _publicNews, _adminNews } = useSelector(state => state.news);
  const { _rate } = useSelector(state => state.rate);
  
  useEffect(() => {
    RateService.ratesGet();
    NewsService.publicNewsGet();
    NewsService.adminNewsGet();
  }, []);

  const deletePublic = (newsItem) => (e) => {
    e.preventDefault();
    var id = newsItem.id;
    console.log(id);
    NewsService.publicNewsDelete({
      id: id
    }).catch(function (err) {
      alert('Der opstod en fejl');
      console.log("error deleting", err);
    });
    NewsService.publicNewsGet();
    return;
  };

  const savePublicEdit = (newsItem, content) => (e) => {
    e.preventDefault();
    var id = newsItem.id;
    NewsService.publicNewsPut({
      id: id,
      content: content
    });
    NewsService.publicNewsGet();
    return;
  };

  const deleteAdmin = (newsItem) => (e) => {
    e.preventDefault();
    var id = newsItem.id;
    console.log(id);
    NewsService.adminNewsDelete({
      id: id
    }).catch(function (err) {
      alert('Der opstod en fejl');
      console.log("error deleting", err);
    });
    NewsService.adminNewsGet();
    return;
  };

  const saveAdminEdit = (newsItem, content) => (e) => {
    e.preventDefault();
    var id = newsItem.id;
    NewsService.adminNewsPut({
      id: id,
      content: content
    });
    NewsService.adminNewsGet();
    return;
  };


  // Modern functional component for News Entry
  const NewsEntryComponent = ({ news: newsItem }) => {
    const [editNews, setEditNews] = useState(false);
    const [content, setContent] = useState(newsItem.content);

    const onClick = () => {
      console.log(editNews);
      setEditNews(!editNews);
    };

    const onTextChange = (value) => {
      setContent(value);
    };

    return (
      <React.Fragment>
        <button className="floatRight btn btn-xs textAlignCenter" onClick={deletePublic(newsItem)}><span className='bi bi-circle-fill'></span></button>
        <button className="floatRight btn btn-xs textAlignCenter" onClick={onClick}><span className='bi bi-document-text'></span></button>
        <div className="card card-default" style={{ marginBottom: "4em" }}>
          <div>
            {editNews ?
              <React.Fragment>
                <div className="card-body">
                  <ReactQuill theme="snow" value={content} onChange={onTextChange} />
                </div>
                <button className="floatRight btn btn-success btn-sm textAlignCenter" onClick={savePublicEdit(newsItem, content)} > Gem ændringer</button>
              </React.Fragment>
              :
              <div className="card-body">
                <div dangerouslySetInnerHTML={{ __html: content }}></div>
              </div>
            }
          </div>
        </div>
      </React.Fragment>
    );
  };

  // Modern functional component for Admin News Entry
  const AdminNewsEntryComponent = ({ news: newsItem }) => {
    console.log(newsItem);
    const [editNews, setEditNews] = useState(false);
    const [content, setContent] = useState(newsItem.content);

    const onClick = () => {
      console.log(editNews);
      setEditNews(!editNews);
    };

    const onTextChange = (value) => {
      setContent(value);
    };

    return (
      <React.Fragment>
        <button className="floatRight btn btn-xs textAlignCenter" onClick={deleteAdmin(newsItem)}><span className='bi bi-circle-fill'></span></button>
        <button className="floatRight btn btn-xs textAlignCenter" onClick={onClick}><span className='bi bi-document-text'></span></button>
        <div className="card card-default" style={{ marginBottom: "3em" }}>
          <React.Fragment>
            {editNews ?
              <div>
                <div className="card-body">
                  <ReactQuill theme="snow" value={content} onChange={onTextChange} />
                </div>
                <button className="floatRight btn btn-success btn-sm textAlignCenter" onClick={saveAdminEdit(newsItem, content)} > Gem ændringer</button>
              </div>
              :
              <div className="card-body">
                <div dangerouslySetInnerHTML={{ __html: content }}></div>
              </div>
            }
          </React.Fragment>
        </div>
      </React.Fragment>
    );
  };

  var newsEntries = null;
  if (_publicNews) {
    newsEntries = _publicNews.map(function (newsEntry) {
      return (
        <NewsEntryComponent news={newsEntry} key={newsEntry.id} />
      );
    });
  }

  var adminNewsEntriers = null;
  if (_adminNews) {
    adminNewsEntriers = _adminNews.map(function (newsEntry) {
      return (
        <AdminNewsEntryComponent news={newsEntry} key={newsEntry.id}/>
      );
    });
  }

  return (
    <div>
      <div className="container">
        <div className="row">
            <div className="standardBackground col-md-12">
              <h2 className="textAlignCenter">Velkommen til Vanløsegaard!</h2>
              {_rate && <div className="textAlignCenter">
                Andelskronen er
              <Link className="Navigation-link" to="indstillinger">{_rate} kr.</Link>
              </div>}
              <h2 className="textAlignCenter">Opslag</h2>
              {adminNewsEntriers}
              <h2 className="textAlignCenter">Offentlige nyheder</h2>
              {newsEntries}
            </div>
        </div>
      </div>
    </div>
  );
}

export default AuthenticatedComponent(Home)